export default {"src":"/_next/static/media/muffin.1e2de24c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};